import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Col, Image } from 'react-bootstrap';
import { getRequest } from '../../../Helper/ApiClient';
import { ProductSizeInterface } from '../../../../Interface/ProductSize';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useAtom } from 'jotai';
import { sellSheetOpenAtom } from '../../../Atoms/SellSheetOpen';

export default function ProductSizeSellSheet({
  product_size,
}: {
  product_size: ProductSizeInterface;
}) {
  const [open, setOpen] = useAtom(sellSheetOpenAtom(product_size.id));
  if (!open) return null;
  return (
    <Col>
      <div className="d-flex flex-column align-items-center w-100 bg-light-gray px-3 px-md-5 py-3 py-md-4">
        <div
          className="align-self-end cursor-pointer text-white mb-2"
          onClick={() => setOpen(false)}
        >
          <FontAwesomeIcon size="2x" icon={faTimes} />
        </div>
        {product_size.product?.sell_sheets?.map((sellSheet, key) => {
          if (sellSheet.is_image) {
            return (
              <Image
                key={key}
                fluid
                className="w-100 my-2"
                src={sellSheet.public_link}
              />
            );
          }
          if (sellSheet.is_youtube) {
            return (
              <p className="w-100 my-2" key={key}>
                <iframe
                  className="w-100"
                  src={sellSheet.public_link}
                  style={{ aspectRatio: '16/9' }}
                />
              </p>
            );
          }
          return null;
        })}
      </div>
    </Col>
  );
}
